/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable no-console */
import React from "react";
import Typography from "@mui/material/Typography";
import { useSelector } from "react-redux";

export default function CountdownTimer() {
  const sessionTime = useSelector((state) => state.session.sessionTime);
  const [counter, setCounter] = React.useState(sessionTime);
  React.useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    if (counter === 0) {
      console.debug("Countdown finished !!!");
      setCounter("SESSION EXPIRED");
    }
    return () => clearInterval(timer);
  }, [counter]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        align: "center",
      }}
    >
      <Typography
        variant='h7'
        color='#77b900'
        sx={{
          display: { xs: "none", md: "flex", color: "white" },
        }}
      >
        TIME REMAINING:{" "}
        <Typography
          variant='h7'
          color='#77b900'
          sx={{
            display: {
              xs: "none",
              md: "flex",
              color:
                counter <= 15 || counter === "SESSION EXPIRED"
                  ? "red"
                  : "white",
              marginLeft: 2,
              fontWeight: "bold",
            },
          }}
        >
          {counter}
        </Typography>
      </Typography>
    </div>
  );
}
